<template lang="html">
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap>
        <v-flex lg9>
          <p class="table_card__head--title">Nuevo formulario</p>
          <v-breadcrumbs class="breadcums">
            <v-icon slot="divider">chevron_right</v-icon>
            <v-breadcrumbs-item
              @click="$router.go(-1)"
              class="breadcums__option"
            >
              Formularios
            </v-breadcrumbs-item>
            <v-breadcrumbs-item
              disabled
              class="breadcums__disable"
            >
              Nuevo formulario
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
        <v-flex lg3 class="filter_options">
          <v-flex class="right mr-1">
            <button
              class="faccess_button px-5"
              @click="saveForm(2)"
            >
                Guardar
            </button>
          </v-flex>
          <v-flex class="right mr-1">
            <button
              class="faccess_button px-5"
              @click="saveForm(1)"
            >
                Enviar
            </button>
          </v-flex>
        </v-flex>

      </v-layout>
    </div>

     <div class="table_card__body" v-show="false">
         <section>
            <div class="offer_elements__condition--new_info_container" style="margin-top: 0px; margin-bottom: -50px;">
                <v-flex lg3>

                    <span style="display: block; margin-top: 30px;"
                    class="table_card__info--label">Tipo de formulario</span>
                    <v-select
                    label="Selecciona"
                    v-bind:items="form_types"
                    :item-text="'form_type'"
                    :item-value="'id'"
                    v-model="idFormType"
                    single-line
                    bottom
                    solo
                    color="#1476FB"
                    ></v-select>
                </v-flex>
            </div>
        </section>
    </div>

    <div class="table_card__body">
      <section>
        <div class="offer_elements__condition--new_info_container">
          <p class="agreement__text--small_gray">Nombre</p>
          <v-flex lg6>
            <v-text-field
              single-line
              name="name"
              label="Nombre del formulario"
              type="text"
              v-model="formName"></v-text-field>
          </v-flex>

          <v-flex lg3>
            <v-checkbox
              v-model="popup"
              label="Mostrar formulario en popup"
            ></v-checkbox>
          </v-flex>

          <div class="offer_elements__condition--element_container">
            <div class="offer_elements__condition--requirement" v-for="(question, index) in questions">
              <p class="agreement__text--small_gray">Tipo de pregunta</p>
              <div class="offer_elements__condition--action_row_requirement">
                <div class="dashboard__options--input with_box_shadow offer_elements__condition--select"
                  @click="question.modal=!question.modal" style="width:69%">


                  <p >{{question.selectedOption!=''?question.selectedOption:'Selecciona un tipo de pregunta'}}</p>

                  <img  src="https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_down.svg">
                  <div v-if="question.modal" class="offer_elements__condition--options">

                    <template v-for="option in question_types">
                      <v-hover>
                        <div slot-scope="{ hover }" @click="selectQuestionType(index,option)"  :class="hover?'offer_elements__interaction--hover':''" class="offer_elements__condition--options_item" >
                          <p>{{option.question_type}}</p>
                        </div>
                      </v-hover>
                    </template>

                  </div>
                </div>
                <v-hover>
                  <button  @click="removeQuestionType(index)" slot-scope="{ hover }" :class="hover?'offer_elements__interaction--hover_delete':''" class="offer_elements__button--add_requirement with_box_shadow offer_elements__interaction--border_gray">
                    <div class="offer_elements__button--delete_requirement " :class="hover?'offer_elements__interaction--hover_delete_background':''">
                      <p>x</p>
                    </div>
                  </button>
                </v-hover>
              </div>

              <v-flex xs12 v-if="question.id_question_type == 1">
                <p class="agreement__text--small_gray">Pregunta</p>
                <v-text-field
                  name="name"
                  label="Pregunta"
                  type="text"
                  single-line
                  v-model="question.short_question.attribute_json.title"
                  ></v-text-field>
              </v-flex>

              <v-flex xs12 v-if="question.id_question_type == 2">
                <p class="agreement__text--small_gray">Pregunta</p>
                <v-text-field
                  name="name"
                  label="Pregunta"
                  type="text"
                  single-line
                  v-model="question.long_question.attribute_json.title"
                  ></v-text-field>
              </v-flex>

              <v-flex xs12 v-if="question.id_question_type == 3">

                  <p class="agreement__text--small_gray">Pregunta</p>
                  <v-text-field
                    name="name"
                    label="Pregunta"
                    type="text"
                    single-line
                    v-model="question.multiple_answer_question_m.attribute_json.title"
                    ></v-text-field>

              <br>
                <p class="agreement__text--small_gray ">Añadir opción</p>
                  <div class="offer_elements__condition--add_container  ">
                      <v-hover>
                      <button @click="addOptionM(index)" slot-scope="{ hover }" :class="hover?'accessIndex__interaction--hover_add':''" class="offer_elements__button--add_requirement with_box_shadow offer_elements__interaction--border_blue">
                          +
                      </button>
                      </v-hover>
                  </div>


                  <v-flex xs6 v-for="(answerOption, idx) in question.multiple_answer_question_m.options">

                    <div class="offer_elements__condition--action_row_requirement">

                    <v-text-field
                      name="name"
                      :label="`Opción ${idx+1}`"
                      type="text"
                      single-line
                      v-model="answerOption.title"
                    ></v-text-field>

                    <v-hover>
                      <button  @click="removeOptionM(index,idx)"  style="margin-left:10px;" slot-scope="{ hover }" :class="hover?'offer_elements__interaction--hover_delete':''" class="offer_elements__button--add_requirement with_box_shadow offer_elements__interaction--border_gray">
                        <div class="offer_elements__button--delete_requirement " :class="hover?'offer_elements__interaction--hover_delete_background':''">
                          <p>x</p>
                        </div>
                      </button>
                    </v-hover>

                </div>

                  </v-flex>
              </v-flex>


              <v-flex xs12 v-if="question.id_question_type == 4">

                  <p class="agreement__text--small_gray">Pregunta</p>
                  <v-text-field
                    name="name"
                    label="Pregunta"
                    type="text"
                    single-line
                    v-model="question.multiple_answer_question_u.attribute_json.title"
                    ></v-text-field>


              <br>
                <p class="agreement__text--small_gray ">Añadir opción</p>
                  <div class="offer_elements__condition--add_container  ">
                      <v-hover>
                      <button @click="addOptionU(index)" slot-scope="{ hover }" :class="hover?'accessIndex__interaction--hover_add':''" class="offer_elements__button--add_requirement with_box_shadow offer_elements__interaction--border_blue">
                          +
                      </button>
                      </v-hover>
                  </div>



                  <v-flex xs6 v-for="(answerOption, idx) in question.multiple_answer_question_u.options">

                     <div class="offer_elements__condition--action_row_requirement">

                      <v-text-field
                        name="name"
                        :label="`Opción ${idx+1}`"
                        type="text"
                        single-line
                        v-model="answerOption.title"
                      ></v-text-field>

                      <v-hover>
                        <button  @click="removeOptionU(index,idx)"  style="margin-left:10px;" slot-scope="{ hover }" :class="hover?'offer_elements__interaction--hover_delete':''" class="offer_elements__button--add_requirement with_box_shadow offer_elements__interaction--border_gray">
                          <div class="offer_elements__button--delete_requirement " :class="hover?'offer_elements__interaction--hover_delete_background':''">
                            <p>x</p>
                          </div>
                        </button>
                      </v-hover>

                    </div>

                  </v-flex>

                </v-flex>

                <v-flex xs12 v-if="question.id_question_type == 5">

                  <p class="agreement__text--small_gray">Pregunta</p>
                  <v-text-field
                    name="name"
                    label="Pregunta"
                    type="text"
                    single-line
                    v-model="question.upload_file.attribute_json.title"
                    ></v-text-field>

                <v-flex xs6>
                    <v-text-field
                    name="name"
                    label="Tamaño máximo de archivo(MB)"
                    type="number"
                    single-line
                    v-model="question.upload_file.file_types.size"
                    ></v-text-field>
                </v-flex>

                    <v-switch
                    v-model="question.upload_file.attribute_json.switch"
                    label="Permitir solo ciertos tipos de archivo"
                  ></v-switch>

                  <div v-if="question.upload_file.attribute_json.switch == true">

                    <v-checkbox
                      v-model="question.upload_file.file_types.document"
                      label="Documento"
                      color="primary"
                      hide-details
                    ></v-checkbox>

                    <v-checkbox
                      v-model="question.upload_file.file_types.xlsx"
                      label="Hoja de cálculo"
                      color="primary"
                      hide-details
                    ></v-checkbox>

                    <v-checkbox
                      v-model="question.upload_file.file_types.pdf"
                      label="PDF"
                      color="primary"
                      hide-details
                    ></v-checkbox>

                    <v-checkbox
                      v-model="question.upload_file.file_types.video"
                      label="Video"
                      color="primary"
                      hide-details
                    ></v-checkbox>

                    <v-checkbox
                      v-model="question.upload_file.file_types.image"
                      label="Imagen"
                      color="primary"
                      hide-details
                    ></v-checkbox>

                    <v-checkbox
                      v-model="question.upload_file.file_types.audio"
                      label="Audio"
                      color="primary"
                      hide-details
                    ></v-checkbox>

                  </div>

                </v-flex>

            </div>

            <v-flex xs6>
              <p class="agreement__text--small_gray ">Pregunta</p>
              <div class="offer_elements__condition--add_container  ">
                <v-hover>
                  <button @click="addQuestion()" slot-scope="{ hover }" :class="hover?'accessIndex__interaction--hover_add':''" class="offer_elements__button--add_requirement with_box_shadow offer_elements__interaction--border_blue">
                    +
                  </button>
                </v-hover>
              </div>
            </v-flex >
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>


export default {
  data() {
    return {
      form_types:[],
      question_types:[],
      idFormType:'',
      idQuestionType:'',
      questions:[],
      formName:'',
      popup:false

    };
  },
  mounted() {

    this.getFormTypes()
    this.getQuestionTypes()

  },
  methods: {



    getFormTypes(){

       try {
        this.$http.get('forms/form_types',{
            params:{
            company:{id:this.getCompany().id
          },
            headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}}}
          )
        .then(function(response){
          this.form_types = response.body.data
          console.log('form types ', response.body.data)


        })
      } catch (e) {
        alert(e.message)
      }

    },


    getQuestionTypes(){

       try {
        this.$http.get('forms/question_types',{
            params:{
            company:{id:this.getCompany().id
          },
            headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}}}
          )
        .then(function(response){


            this.question_types = response.body.data

          console.log('question types ', this.question_types)


        })
      } catch (e) {
        alert(e.message)
      }


    },


    saveForm(state){

      console.log('this.questions.length ', this.questions)

       var check=true

      if(this.questions.length == 0){

          this.updateAlertMessage('Debes agregar al menos 1 pregunta');
          this.updateIsInAlert(true);


      }else if(this.formName == ''){

          this.updateAlertMessage('Debes agregar un nombre de formulario');
          this.updateIsInAlert(true);

      }else{



      this.questions.forEach((question) => {

          if(question.id_question_type == 1){
              if( question.short_question.attribute_json.title == ''){
                    check = false
                    this.updateAlertMessage('Debes agregar el encabezado de la pregunta');
                    this.updateIsInAlert(true);
              }

          }else if(question.id_question_type == 2){
              if( question.long_question.attribute_json.title == ''){
                    check = false
                    this.updateAlertMessage('Debes agregar el encabezado de la pregunta');
                    this.updateIsInAlert(true);
              }

          }else if(question.id_question_type == 3){
              if( question.multiple_answer_question_m.attribute_json.title == ''){
                    check = false
                    this.updateAlertMessage('Debes agregar el encabezado de la pregunta');
                    this.updateIsInAlert(true);
              }
              if( question.multiple_answer_question_m.options.length == 0){
                    check = false
                    this.updateAlertMessage('Debes agregar al menos una opción en la pregunta con opción múltiple');
                    this.updateIsInAlert(true);
              }

          }else if(question.id_question_type == 4){
              if( question.multiple_answer_question_u.attribute_json.title == ''){
                    check = false
                    this.updateAlertMessage('Debes agregar el encabezado de la pregunta');
                    this.updateIsInAlert(true);
              }
              if( question.multiple_answer_question_u.options.length == 0){
                    check = false
                    this.updateAlertMessage('Debes agregar al menos una opción en la pregunta con opción múltiple');
                    this.updateIsInAlert(true);
              }
          }else if(question.id_question_type == 5){
              if( question.upload_file.attribute_json.title == ''){
                    check = false
                    this.updateAlertMessage('Debes agregar el encabezado de la pregunta');
                    this.updateIsInAlert(true);
              }

          }

      });

    if( check == true ){

      let finalJson={form: this.questions,popup: this.popup, form_type_id: 2,company_id: this.getCompany().id, form_name: this.formName, form_state_id: state}

        this.$http.post('forms/create_form',{
              data: this.encrypt(finalJson).toString()
            },{
              headers: {
                "X-Device-ID" : this.getDeviceId(),
                "Authorization" : 'Bearer ' + this.getUserToken()
              }}).then(function(response){

                this.updateAlertMessage(response.body.data);
                this.updateIsInAlert(true);

                this.$router.push({
                  name: 'forms_index'
                })

                this.questions = []
                this.formName = ''
                this.idFormType = ''
                this.popup = false


              if(response.body.meta != undefined && response.body.meta != null){
                if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                  this.checkToken(response.body.meta.authentication_token)
                }
              }
            }, function(response){
              if(response.body.meta != undefined && response.body.meta != null){
                if(response.body.meta0authentication_token != undefined && response.body.meta.authentication_token != null){
                  this.checkToken(response.body.meta.authentication_token)
                }
              }
            })

    }


      }


    },




    removeQuestionType(index) {
      this.questions.splice(index, 1);
      console.log('this.questions', this.questions)
    },

    removeOptionM(index,idx){

      this.questions[index].multiple_answer_question_m.options.splice(idx, 1);

    },

    removeOptionU(index,idx){

      this.questions[index].multiple_answer_question_u.options.splice(idx, 1);

    },


    addOptionM(index) {

      var option = new Object()
      option.title = ''

      this.questions[index].multiple_answer_question_m.options.push(option)

      console.log('questions',this.questions)

    },

    addOptionU(index) {

      var option = new Object()
      option.title = ''

      this.questions[index].multiple_answer_question_u.options.push(option)

      console.log('questions',this.questions)


    },

    addQuestion() {

      var question = {


        selectedOption: "",
        modal: false,

        id_question_type:'',

        short_question: {
          attribute_json: {
            id: 1,
            title: "",
            answer: ""
          }
        },

        long_question: {
          attribute_json: {
            id: 2,
            title: "",
            answer: ""
          }
        },

        multiple_answer_question_m: {
          attribute_json: {
            id: 3,
            title: "",
            answer: ""
          },
          options:[]
        },

        multiple_answer_question_u: {
          attribute_json: {
            id: 4,
            title: "",
            answer: ""
          },
          options:[]
        },

        upload_file: {
          attribute_json: {
            id: 5,
            switch: false,
            title: "",
            answer: ""
          },
          file_types:{
            size: '',
            document: true,
            xlsx: true,
            pdf: true,
            video: true,
            image: true,
            audio: true
          }
        },

      };

        this.questions.push(question)
        console.log('this.questions',this.questions)
    },

    selectQuestionType(index, option) {
      console.log('es option', option)

      this.questions[index].id_question_type = option.id;
      this.questions[index].selectedOption = option.question_type;

    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/forms/New_form.vue